export default __webpack_public_path__ + "static/media/unavailableBG_month.6d795a2a.svg";